import { format } from "date-fns";
import api from "../services/api";

interface IPaymentsConferenceResponse {
    codeResult: string;
    data: any[];
}

export interface IPaymentsParams {
    year: string;
    month: string;
    regionalId: string;
    sectorId: string;

}
export interface IPaymentsConference {
    representante: string;
    valorEmpresa: number;
    valorRecebido: number;
}

class PaymentsConferenceRepository {
    public async AgentMonth({ year, month, regionalId, sectorId }: IPaymentsParams): Promise<IPaymentsConference[]> {
        const initialDate = format(new Date(parseInt(year), parseInt(month) - 1, 1, 0, 0, 0), "yyyy-MM-dd HH:mm:ss");
        const endDate = format(new Date(parseInt(year), parseInt(month), 1, 0, 0, 0), "yyyy-MM-dd HH:mm:ss");

        const body = {
            "tables": ["Representante", "Conference", "GerenteSetor", "GerenteRegional", "Entradas"],
            "sql": [
                {
                    "coderesult": "DadosRp",
                    "query": `SELECT Representante.id as IdRep, 
                    Representante.nome as Nome, 
                    Representante.data as Data 
                    FROM Representante 
                    INNER JOIN GerenteSetor 
                    ON GerenteSetor.id = Representante.gerenteSetorId 
                    WHERE Representante.status IN(0,1) 
                    ${sectorId.length > 0 ? `AND Representante.gerenteSetorId = '${sectorId}' ` : ""}
                    ${regionalId.length > 0 ? `AND GerenteSetor.gerenteRegionalId = '${regionalId}' ` : ""}                    
                    GROUP BY Representante.id, Representante.nome, Representante.data`
                },
                {
                    "coderesult": "ValorEmpresa",
                    "query": `SELECT Conference.representanteId as IdRep, 
                    (SUM(Conference.valorRecebido) - SUM(Conference.comissaoRepresentante)) as ValorEmpresa 
                    FROM Conference 
                    INNER JOIN Representante 
                    ON Representante.id = Conference.representanteId 
                    INNER JOIN GerenteSetor 
                    ON GerenteSetor.id = Representante.gerenteSetorId 
                    INNER JOIN GerenteRegional 
                    ON GerenteRegional.id = GerenteSetor.gerenteRegionalId 
                    WHERE Conference.conferenceType = 0 
                    AND Conference.data >= '${initialDate}' 
                    AND Conference.data < '${endDate}' 
                    ${regionalId.length > 0 ? `AND GerenteRegional.id = '${regionalId}' ` : ""}
                    ${sectorId.length > 0 ? `AND GerenteSetor.id = '${sectorId}' ` : ""} 
                    GROUP BY Conference.representanteId`
                },
                {
                    "coderesult": "ValorEntradas",
                    "query": `SELECT representanteId as IdRep, 
                    SUM(valorEntrada) as ValorEntradas 
                    FROM Entradas 
                    WHERE dataComprovante >= '${initialDate}' 
                    AND dataComprovante < '${endDate}' 
                    ${regionalId.length > 0 ? `AND gerenteRegionalId = '${regionalId}' ` : ""}
                    ${sectorId.length > 0 ? `AND gerenteSetorId = '${sectorId}' ` : ""} 
                    GROUP BY representanteId`
                }
            ]
        };

        const response = await api.post<IPaymentsConferenceResponse[]>("reports", body);
        const representanteResponse = this.GetFromCodeResult(response.data, "DadosRp");
        const valorEmpresaResponse = this.GetFromCodeResult(response.data, "ValorEmpresa");
        const valorEntradasResponse = this.GetFromCodeResult(response.data, "ValorEntradas");

        return representanteResponse.map(dadosRepresentante => {
            const dadosFaturamento = valorEmpresaResponse.find(valorEmpresaDado => valorEmpresaDado.IdRep === dadosRepresentante.IdRep);
            const dadosEntradas = valorEntradasResponse.find(valorEntradasDado => valorEntradasDado.IdRep === dadosRepresentante.IdRep);
            return {
                representante: dadosRepresentante.Nome,
                valorEmpresa: dadosFaturamento?.ValorEmpresa || 0,
                valorRecebido: dadosEntradas?.ValorEntradas || 0
            }
        }).filter(valorMinimo => valorMinimo.valorEmpresa > 0)
        .sort((a, b) => (a.valorRecebido - a.valorEmpresa) - (b.valorRecebido - b.valorEmpresa))
    }

    GetFromCodeResult(data: IPaymentsConferenceResponse[], codeResult: string) {

        return data.find(result => result.codeResult === codeResult)?.data || [];
    }
}

const paymentsConferenceRepository = new PaymentsConferenceRepository();
export default paymentsConferenceRepository;